import { PaymentJobCategory } from "dtos/payment.job.dto";

export type TabKey = PaymentJobCategory | "charge_attempts";
export const CHARGE_ATTEMPTS_TAB: TabKey = "charge_attempts";

export const REFRESH_OPTIONS = [
  { label: "5s", value: 5 },
  { label: "10s", value: 10 },
  { label: "15s", value: 15 },
  { label: "20s", value: 20 },
] as const;

export const LS_REFRESH_ENABLED = "pjm:autoRefresh:enabled";
export const LS_REFRESH_INTERVAL = "pjm:autoRefresh:interval";
